// extracted by mini-css-extract-plugin
export default {"about":"About_about__tFYRZ","focus":"About_focus__VxAVe","link":"About_link__6TTmW","img":"About_img__ThOzN","moments":"About_moments__Jaxwh","removed":"About_removed__Cxqm2"};